const HelpYellow = ({ size = 54, onClick }) => (
  <svg
    id="HelpYellow"
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    onClick={onClick}
  >
    <path
      d="M12.9805 21.5288C17.7408 21.5288 21.5997 17.6699 21.5997 12.9096C21.5997 8.14935 17.7408 4.2904 12.9805 4.2904C8.22027 4.2904 4.36133 8.14935 4.36133 12.9096C4.36133 17.6699 8.22027 21.5288 12.9805 21.5288Z"
      fill="#FEC212"
    />
    <path
      d="M11.0047 20.1608C8.59352 20.1608 6.31672 19.2112 4.59272 17.488C2.86952 15.7648 1.91992 13.4872 1.91992 11.076C1.91992 8.6648 2.86952 6.388 4.59272 4.664C6.31592 2.9408 8.59352 1.9912 11.0047 1.9912C13.4159 1.9912 15.6927 2.9408 17.4167 4.664C19.1399 6.3872 20.0895 8.6648 20.0895 11.076C20.0895 11.3408 19.8743 11.556 19.6095 11.556C19.3447 11.556 19.1295 11.3408 19.1295 11.076C19.1295 8.9216 18.2799 6.8856 16.7375 5.3432C15.1951 3.8008 13.1591 2.9512 11.0047 2.9512C8.85032 2.9512 6.81352 3.8008 5.27192 5.3432C3.72952 6.8856 2.87992 8.9216 2.87992 11.076C2.87992 13.2304 3.72952 15.2672 5.27192 16.8088C6.81432 18.3512 8.85032 19.2008 11.0047 19.2008C13.5239 19.2008 15.9399 18.0048 17.4671 16.0008C17.6279 15.7896 17.9287 15.7488 18.1399 15.9096C18.3511 16.0704 18.3911 16.3712 18.2311 16.5824C16.5239 18.8232 13.8223 20.1608 11.0055 20.1608H11.0047Z"
      fill="#5A348C"
    />
    <path
      d="M11.0052 16.32C10.6516 16.32 10.3652 16.0336 10.3652 15.68V10.02C10.3652 9.6664 10.6516 9.38 11.0052 9.38C11.3588 9.38 11.6452 9.6664 11.6452 10.02V15.68C11.6452 16.0336 11.3588 16.32 11.0052 16.32Z"
      fill="#5A348C"
    />
    <path
      d="M11.0049 8.0664C11.5082 8.0664 11.9161 7.65844 11.9161 7.1552C11.9161 6.65196 11.5082 6.244 11.0049 6.244C10.5017 6.244 10.0938 6.65196 10.0938 7.1552C10.0938 7.65844 10.5017 8.0664 11.0049 8.0664Z"
      fill="#5A348C"
    />
  </svg>
);

export default HelpYellow;
